import { LOGIN_INFO } from '../constant';

interface UserInfoVo {
    readonly account?: string;
    readonly id?: string;
    readonly name?: string;
    readonly token?: string;
}

export function getToken(): string | undefined {
    const userInfoStr = window.localStorage.getItem(LOGIN_INFO);
    let token;

    if (userInfoStr) {
        try {
            token = (JSON.parse(userInfoStr) as UserInfoVo).token;
        } catch {
            token = undefined;
        }
    }

    return token;
}

export function getUserInfo() {
    const userInfoStr = window.localStorage.getItem(LOGIN_INFO);
    let userInfoTmp = {};

    if (userInfoStr) {
        try {
            userInfoTmp = JSON.parse(userInfoStr);
        } catch {
            userInfoTmp = {};
        }
    }

    const userInfo: UserInfoVo = userInfoTmp;

    return userInfo;
}
